export default {
  "title": "سياسة ملفات الارتباط",
  "lastUpdated": "آخر تحديث: ٢٦ مايو ٢٠٢٦",
  "back": "← العودة إلى الصفحة الرئيسية",
  "intro": [
    {
      "type": "p",
      "text": "توضح سياسة ملفات الارتباط هذه كيف تستخدم Demakstore Gıda İhracat San. ve Tic. Ltd. Şti.، المشغِّلة لعلامة DeMaxtore («DeMaxtore»، «نحن»، «لنا»)، ملفات الارتباط والتقنيات المماثلة على www.demaxtore.com."
    },
    {
      "type": "p",
      "text": "باستخدام موقعنا، يمكنك قبول ملفات ارتباط معينة أو رفضها أو إدارتها حسب الغرض منها. بعض ملفات الارتباط ضرورية لعمل الموقع بشكل صحيح، بينما تُستخدم أخرى لتحسين التجربة وتحليل الأداء ودعم الأنشطة التسويقية."
    }
  ],
  "sections": [
    {
      "title": "١. إدارة تفضيلات ملفات الارتباط",
      "blocks": [
        {
          "type": "p",
          "text": "قد تعتمد بعض وظائف موقعنا على خدمات مقدمة من أطراف ثالثة. إذا منحت موافقتك، قد يضع هؤلاء الأطراف ملفات ارتباط أو تقنيات مماثلة على جهازك لتمكينك من عرض محتوى مستضاف لديهم أو التفاعل معه أو مشاركته."
        },
        {
          "type": "p",
          "text": "قد تسمح هذه الملفات للأطراف الثالثة بجمع بيانات التصفح واستخدامها لأغراضها الخاصة، وفقاً لسياسات الخصوصية وملفات الارتباط الخاصة بها."
        },
        {
          "type": "p",
          "text": "يمكنك منح موافقتك أو سحبها في أي وقت، إما عالمياً أو حسب فئة ملفات الارتباط، حيثما تتوفر هذه الخيارات."
        },
        {
          "type": "p",
          "text": "افتراضياً، لا تُوضع ملفات الارتباط غير الضرورية ما لم تقدم موافقتك، حيث يقتضي القانون المعمول به ذلك."
        }
      ]
    },
    {
      "title": "٢. نبذة عن ملفات الارتباط",
      "blocks": [
        {
          "type": "p",
          "text": "نستخدم أنواعاً مختلفة من ملفات الارتباط على موقعنا لضمان عمله بشكل صحيح، وقياس نشاط الجمهور، وتحسين الأداء، وتعزيز تفاعل خدماتنا."
        },
        {
          "type": "p",
          "text": "قد تساعدنا ملفات الارتباط على فهم كيفية استخدام الزوار لموقعنا، والصفحات التي يزورونها، وكيفية تفاعلهم مع خدماتنا، وكيفية تحسين تجربة الموقع."
        }
      ]
    },
    {
      "title": "٣. ما هو ملف الارتباط؟",
      "blocks": [
        {
          "type": "p",
          "text": "ملف الارتباط هو ملف نصي صغير أو معلومة قد تُخزَّن على جهازك عند زيارة موقع إلكتروني."
        },
        {
          "type": "p",
          "text": "تسمح ملفات الارتباط للموقع بالتعرف على متصفحك أو جهازك أثناء الزيارة أو عند العودة لاحقاً. وقد تُستخدم لأغراض مثل:"
        },
        {
          "type": "ul",
          "items": [
            "تأمين الموقع",
            "تذكر تفضيلات المستخدم",
            "الحفاظ على معلومات الجلسة",
            "قياس حركة الموقع",
            "تحسين وظائف الموقع",
            "دعم التحليلات والتسويق",
            "تمكين محتوى أو تكاملات طرف ثالث"
          ]
        },
        {
          "type": "p",
          "text": "قد تكون ملفات الارتباط مؤقتة (تُحذف عند إغلاق المتصفح) أو دائمة (تبقى على جهازك لفترة محددة)."
        }
      ]
    },
    {
      "title": "٤. أنواع ملفات الارتباط التي نستخدمها",
      "blocks": [
        {
          "type": "p",
          "text": "قد تستخدم DeMaxtore الأنواع التالية من ملفات الارتباط:"
        }
      ]
    },
    {
      "title": "٤.١ ملفات الارتباط الضرورية للغاية",
      "blocks": [
        {
          "type": "p",
          "text": "هذه الملفات مطلوبة لعمل الموقع بشكل صحيح. وتتيح وظائف أساسية مثل:"
        },
        {
          "type": "ul",
          "items": [
            "التنقل بين الصفحات",
            "الأمان",
            "إدارة جلسة المستخدم",
            "إرسال النماذج",
            "إدارة تفضيلات ملفات الارتباط",
            "الوصول إلى المناطق الآمنة"
          ]
        },
        {
          "type": "p",
          "text": "يمكنك حظرها تقنياً من إعدادات المتصفح، لكن قد تتوقف أجزاء من الموقع عن العمل بشكل سليم."
        },
        {
          "type": "p",
          "text": "لا تتطلب هذه الملفات موافقة عندما تكون ضرورية للغاية لتشغيل الموقع."
        }
      ]
    },
    {
      "title": "٤.٢ ملفات الأداء والتحليلات",
      "blocks": [
        {
          "type": "p",
          "text": "تساعدنا هذه الملفات على فهم كيفية استخدام الزوار لموقعنا. وتسمح بقياس وتحليل:"
        },
        {
          "type": "ul",
          "items": [
            "حركة الموقع",
            "مشاهدات الصفحات",
            "سلوك الزوار",
            "الوقت على الصفحات",
            "الأداء التقني",
            "التفاعل مع ميزات الموقع"
          ]
        },
        {
          "type": "p",
          "text": "تساعدنا هذه المعلومات على تحسين هيكل ومحتوى وسرعة وقابلية استخدام www.demaxtore.com."
        },
        {
          "type": "p",
          "text": "لا تُستخدم ملفات التحليلات إلا حيث يسمح القانون بذلك، وعند الاقتضاء، بناءً على موافقتك."
        }
      ]
    },
    {
      "title": "٤.٣ ملفات الارتباط الوظيفية",
      "blocks": [
        {
          "type": "p",
          "text": "تسمح ملفات الارتباط الوظيفية للموقع بتذكر اختياراتك وتقديم ميزات محسّنة."
        },
        {
          "type": "p",
          "text": "قد تشمل:"
        },
        {
          "type": "ul",
          "items": [
            "تفضيلات اللغة",
            "تفضيلات المنطقة",
            "معلومات نماذج أدخلتها سابقاً",
            "تفضيلات الواجهة",
            "تحسينات تجربة المستخدم"
          ]
        },
        {
          "type": "p",
          "text": "إذا عُطّلت هذه الملفات، قد لا تعمل بعض الميزات المخصصة بشكل صحيح."
        }
      ]
    },
    {
      "title": "٤.٤ ملفات التسويق والإعلان",
      "blocks": [
        {
          "type": "p",
          "text": "قد تُستخدم ملفات التسويق لتقديم محتوى أكثر صلة، وقياس الحملات، وفهم فعالية الأنشطة الإعلانية."
        },
        {
          "type": "p",
          "text": "قد تجمع معلومات عن سلوك التصفح على موقعنا، وفي بعض الحالات على مواقع أخرى."
        },
        {
          "type": "p",
          "text": "قد تُوضع من DeMaxtore أو من مزودي إعلان وتحليلات تابعين لطرف ثالث، حسب الأدوات المستخدمة."
        },
        {
          "type": "p",
          "text": "لا تُستخدم ملفات التسويق إلا بموافقتك حيث يقتضي القانون المعمول به ذلك."
        }
      ]
    },
    {
      "title": "٤.٥ ملفات ارتباط الأطراف الثالثة",
      "blocks": [
        {
          "type": "p",
          "text": "قد يعتمد موقعنا على خدمات أطراف ثالثة لتحسين الوظائف والتفاعل والتحليلات والتواصل أو التسويق."
        },
        {
          "type": "p",
          "text": "قد تشمل هذه الخدمات:"
        },
        {
          "type": "ul",
          "items": [
            "مزودي تحليلات المواقع",
            "منصات إعلانية",
            "فيديو أو وسائط مدمجة",
            "أدوات دردشة أو تواصل",
            "تكاملات وسائل التواصل",
            "CRM أو نماذج أو أدوات تتبع",
            "أدوات أمان وأداء"
          ]
        },
        {
          "type": "p",
          "text": "قد يضع هؤلاء الأطراف ملفات ارتباط مباشرة على جهازك عند تفاعلك مع خدماتهم على موقعنا."
        },
        {
          "type": "p",
          "text": "عبر هذه الملفات، قد يجمع الأطراف الثالثون بيانات التصفح ويستخدمونها لأغراضهم، بما في ذلك التحليلات والإعلان المستهدف والتخصيص أو تحسين الخدمة."
        },
        {
          "type": "p",
          "text": "لمزيد من المعلومات، راجع سياسات الخصوصية وملفات الارتباط للمزودين المعنيين."
        }
      ]
    },
    {
      "title": "٥. ملفات ارتباط وظائف الموقع",
      "blocks": [
        {
          "type": "p",
          "text": "بعض ملفات الارتباط ضرورية لوظائف وخدمات الموقع الأساسية. وتساعد على ضمان:"
        },
        {
          "type": "ul",
          "items": [
            "تحميل الموقع بشكل صحيح",
            "عمل نماذج الاتصال",
            "فعالية ميزات الأمان",
            "استمرار جلسات المستخدم",
            "تذكر اختيارات ملفات الارتباط",
            "استقرار ميزات الموقع"
          ]
        },
        {
          "type": "p",
          "text": "بدون هذه الملفات، قد لا تعمل بعض أجزاء الموقع كما هو مقصود."
        }
      ]
    },
    {
      "title": "٦. ملفات لتحسين التفاعل",
      "blocks": [
        {
          "type": "p",
          "text": "قد تستخدم DeMaxtore أدوات طرف ثالث لتحسين تفاعل الموقع، مثل:"
        },
        {
          "type": "ul",
          "items": [
            "فيديوهات مدمجة",
            "نماذج تفاعلية",
            "دردشة مباشرة",
            "مشاركة اجتماعية",
            "عرض محتوى خارجي",
            "لوحات تحليلات",
            "تتبع الحملات التسويقية"
          ]
        },
        {
          "type": "p",
          "text": "قد تستخدم هذه الميزات ملفات ارتباط تابعة لطرف ثالث يضعها مقدمو الخدمة مباشرة."
        },
        {
          "type": "p",
          "text": "إذا لم توافق على هذه الملفات، قد لا يتوفر بعض المحتوى التفاعلي أو ميزات الأطراف الثالثة."
        }
      ]
    },
    {
      "title": "٧. الموافقة على ملفات الارتباط",
      "blocks": [
        {
          "type": "p",
          "text": "حيث يقتضي القانون المعمول به، نطلب موافقتك قبل وضع ملفات ارتباط غير ضرورية على جهازك."
        },
        {
          "type": "p",
          "text": "يمكنك:"
        },
        {
          "type": "ul",
          "items": [
            "قبول جميع ملفات الارتباط",
            "رفض ملفات الارتباط غير الضرورية",
            "إدارة التفضيلات حسب الفئة",
            "سحب موافقتك في أي وقت"
          ]
        },
        {
          "type": "p",
          "text": "إذا سحبت موافقتك، قد تبقى الملفات الموضوعة سابقاً على جهازك حتى تحذفها من المتصفح أو حتى تنتهي صلاحيتها."
        }
      ]
    },
    {
      "title": "٨. كيفية إدارة ملفات الارتباط",
      "blocks": [
        {
          "type": "p",
          "text": "يمكنك إدارة ملفات الارتباط بطريقتين:"
        },
        {
          "type": "p",
          "text": "عبر أداة تفضيلات ملفات الارتباط لدينا"
        },
        {
          "type": "p",
          "text": "حيثما تتوفر، يمكنك إدارة تفضيلاتك عبر شريط ملفات الارتباط أو لوحة الإعدادات على موقعنا."
        },
        {
          "type": "p",
          "text": "عبر إعدادات المتصفح"
        },
        {
          "type": "p",
          "text": "تسمح معظم المتصفحات بـ:"
        },
        {
          "type": "ul",
          "items": [
            "عرض ملفات الارتباط المخزنة",
            "حذف ملفات الارتباط",
            "حظر ملفات الارتباط",
            "تعيين تفضيلات لمواقع معينة",
            "تلقي تحذيرات قبل التخزين"
          ]
        },
        {
          "type": "p",
          "text": "قد يؤثر حظر جميع ملفات الارتباط على وظائف وأداء موقعنا."
        }
      ]
    },
    {
      "title": "٩. مسؤولية الأطراف الثالثة",
      "blocks": [
        {
          "type": "p",
          "text": "ملفات ارتباط الأطراف الثالثة يتحكم بها المزودون المعنيون. لا تتحكم DeMaxtore بالكامل في كيفية استخدام الأطراف الثالثة لملفات الارتباط أو معالجة البيانات عبر تقنياتهم."
        },
        {
          "type": "p",
          "text": "نوصي بمراجعة سياسات الخصوصية وملفات الارتباط لخدمات الأطراف الثالثة التي تتفاعل معها عبر موقعنا."
        }
      ]
    },
    {
      "title": "١٠. تغييرات سياسة ملفات الارتباط",
      "blocks": [
        {
          "type": "p",
          "text": "قد نحدّث سياسة ملفات الارتباط هذه لتعكس تغييرات في موقعنا أو استخدام الملفات أو أدوات الأطراف الثالثة أو المتطلبات القانونية أو العمليات."
        },
        {
          "type": "p",
          "text": "سيُنشر أي تحديث على هذه الصفحة مع تاريخ «آخر تحديث» المنقح."
        }
      ]
    },
    {
      "title": "١١. الاتصال",
      "blocks": [
        {
          "type": "p",
          "text": "للأسئلة حول سياسة ملفات الارتباط هذه أو استخدامنا لملفات الارتباط، تواصل معنا:"
        },
        {
          "type": "ul",
          "items": [
            "Demakstore Gıda İhracat San. ve Tic. Ltd. Şti.",
            "العلامة التشغيلية: DeMaxtore",
            "الموقع: www.demaxtore.com",
            "البريد الإلكتروني: support@demaxtore.com",
            "بريد إلكتروني بديل: demaxtore@demaxtore.com"
          ]
        }
      ]
    }
  ]
};
